import { getLookupPage, readField } from '../api';

export const isUomGuid = value => typeof value === 'string'
    && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value)
    && value !== '00000000-0000-0000-0000-000000000000';
export const sameUomId = (left, right) => isUomGuid(left) && isUomGuid(right) && left.toLowerCase() === right.toLowerCase();
export const matchesBaseUom = (record, commodityId, dimensionId) => sameUomId(readField(record, 'commodityId'), commodityId)
    && sameUomId(readField(record, 'dimensionId'), dimensionId);

// The existing list contract has no documented commodity/dimension filters.
// Read every page so compatible units beyond the first page remain selectable.
export const loadBaseUomRecords = async signal => {
    const records = [];
    const pageSize = 100;
    for (let pageIndex = 0; ; pageIndex += 1) {
        const { items, total } = await getLookupPage('units-of-measurement', {
            pageIndex, pageSize, search: '', sortBy: 'Id', sortDirection: 'asc',
        }, signal);
        records.push(...items);
        if (records.length >= total) return records;
        if (!items.length) throw new Error('Unable to load all base units. Close the form and try again.');
    }
};
